import { EnvironmentProviders, makeEnvironmentProviders } from '@angular/core';
import {
  NgbDateAdapter,
  NgbDateParserFormatter,
} from '@ng-bootstrap/ng-bootstrap';
import { ISODateAdapter } from '../adapters/iso-date.adapter';
import { USDateParserFormatter } from '../adapters/us-date-parser-formatter';

/**
 * App-wide ng-bootstrap datepicker adapters (SEOMS-428).
 *
 * Stores dates as ISO strings (`ISODateAdapter`) and parses/displays them in US
 * format (`USDateParserFormatter`). Relocated from `SharedSharedUiModule`'s
 * `providers` to the app root so the behaviour survives the dismantle of that
 * module — every datepicker in the app now shares one date policy, instead of
 * only the ones whose component tree imported the shim.
 *
 * Register once in `bootstrapApplication(...)` providers (main.ts).
 */
export function provideAppDatepickerAdapters(): EnvironmentProviders {
  return makeEnvironmentProviders([
    { provide: NgbDateAdapter, useClass: ISODateAdapter },
    { provide: NgbDateParserFormatter, useClass: USDateParserFormatter },
  ]);
}
